import { isHubRouteAdminBypass } from '../constants/roles';

const WRITE_COvers = new Set(['create', 'update']);

/**
 * Mirror backend CookiePermissionChecker: ``resource:write`` satisfies
 * ``resource:create`` and ``resource:update`` checks.
 */
export function userHasPermission(user, permission, options = {}) {
  const { adminBypass = false } = options;

  if (!permission) {
    return true;
  }
  if (!user) {
    return false;
  }

  if (
    adminBypass
    && (user.is_superuser || isHubRouteAdminBypass(user.roles || []))
  ) {
    return true;
  }

  const permissions = user.permissions || [];
  if (permissions.includes(permission)) {
    return true;
  }

  const [resource, action] = String(permission).split(':');
  if (!resource || !action || !WRITE_COvers.has(action)) {
    return false;
  }

  return permissions.includes(`${resource}:write`);
}

/** Whether the automations hub should expose the schedules tab for this user. */
export function userHasAnyScheduleAccess(user) {
  if (!user) {
    return false;
  }

  if (
    user.is_superuser
    || user.platform_roles?.includes('admin_wes')
    || isHubRouteAdminBypass(user.roles || [])
  ) {
    return true;
  }

  const permissions = user.permissions || [];
  if (permissions.some((name) => name.startsWith('schedule:'))) {
    return true;
  }

  return (
    userHasPermission(user, 'schedule:read')
    || userHasPermission(user, 'schedule:create')
    || userHasPermission(user, 'schedule:update')
  );
}
